// Components
import { ContextualMenu as FluentContextualMenu, useTheme } from "@fluentui/react";
// Styles
import { getContextualMenuStyles } from "./ContextualMenu.styles";
// Utilities
import * as React from "react";
/**
 * ContextualMenu control that customizes the Fluent control to our own purposes
 */ export function ContextualMenu(props) {
    const { children, ...passThroughProps } = {
        ...props,
        styles: getContextualMenuStyles(useTheme(), props.styles)
    };
    return /*#__PURE__*/ React.createElement(FluentContextualMenu, passThroughProps, props.children);
}
